import Api from "../utils/Api";
import { createParams } from "../utils/ProgUtil";
import * as types from "./Types";

export const getMembers = ({ registeredSinceDays } = {}) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {
      registered_since_days: registeredSinceDays,
    });
    return Api.get(`/admin/members?${params}`);
  };
};

export const sendLetterToMember = (
  memberId,
  letterText,
  giftFeathers,
  giftRunnerId,
) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/send_letter_to_member?${params}`, {
      memberId,
      letterText,
      giftFeathers,
      giftRunnerId,
    });
  };
};

export const getMemberLetterHistory = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member_letter_history/${memberId}?${params}`);
  };
};

export const getMemberFriends = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member_friends/${memberId}?${params}`);
  };
};

export const getMemberUnlockAndFeatherHistory = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(
      `/admin/member_unlock_and_feather_history/${memberId}?${params}`,
    );
  };
};

export const getMemberCharacterSummary = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member_character_summary/${memberId}?${params}`);
  };
};
